<template >
  <b-card title="line">
    <b-card >
      <ChartLineBase2 :chart-data="chartData" height="290"/>
    </b-card>
  </b-card>
</template>

<style>

</style>

<script>
import ChartLineBase2 from "./ChartLineBase2.js";

export default {
  components: {
    ChartLineBase2
  },
  data() {
    return {
      chartData: null
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.chartData = {
        labels: ["sep 9, 2021", "sep 12, 2021", "sep 15, 2021", "sep 18, 2021", "sep 21, 2021", "sep 24, 2021"],
        datasets: [
          // {
          //   type:"line",
          //   backgroundColor: "transparent",
          //   borderColor: "#47b784",
          //   data: [26, 24, 32, 36, 33, 31 ,33 ],
          //   label: "High-2020",
            
          // },
          {
            type:"line",
            backgroundColor: "rgba(50, 115, 220, 0.5)",
            borderColor: "#1967D2",
            data: [20, 38, 64, 36, 52, 45],
            label: "Average Score"
          },
          // {
          //   type:"line",
          //   backgroundColor: "transparent",
          //   borderColor: "#36495d",
          //   data: [14, 11, 16, 12, 17, 13, 12],
          //   label: "Low-2020"
          // }
        ]
      };
    }
  }
};
</script>